import { SUBMIT_SERVICE_REQUEST} from "../../actions/actionTypes";
import { getAuth } from "firebase/auth";
const initialState = {
  loading: false,
};

const reducer = (state = initialState, action) => {
  
  switch (action.type) {
    case SUBMIT_SERVICE_REQUEST.REQUEST:
      return { ...state, loading: true };
    case SUBMIT_SERVICE_REQUEST.FAILURE:
    case SUBMIT_SERVICE_REQUEST.SUCCESS:
        return { ...state, loading: false };
    default:
      return state;
  }
};

export default reducer;
